import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { catchError, Observable, of } from 'rxjs';

import { SnackbarService } from "../../shared/components/snackbar/snackbar.service";
import { Train } from "../models/train.entity";
import { TrainRepository } from "../repositories/train.repository";

@Injectable()
export class TrainResolver  {

  constructor(private readonly trainRepository: TrainRepository,
              private readonly snackbarService: SnackbarService,
              private readonly router: Router,
  ) {
    this.handleError = this.handleError.bind(this);
  }

  resolve(route: ActivatedRouteSnapshot): Observable<Train | undefined> {
    const id = route.paramMap.get('id') ?? '';

    return this.trainRepository.findById(id)
      .pipe(catchError(err => this.handleError(err, id)));
  }

  private handleError(err: HttpErrorResponse, id: string): Observable<Train | undefined> {
    if (err.status === 404) {
      this.snackbarService.pushMessage('Le train recherché est introuvable', 'error');
    } else if (err.status === 403 || err.error?.message === 'train_access_forbidden' || err.error?.message === 'thematic_forbidden') {
      this.snackbarService.pushMessage("Ce parcours n'est pas disponible pour votre organisation.", 'error');
      this.router.navigate([ '/available-trains' ]);
      return of(undefined);
    }
    this.router.navigate([ 'home' ], { queryParams: { manage: true, trainId: id } });

    return of(undefined);
  }
}
